<template lang="pug">
div.main-container
  navigation
  main.page.landing
    section#opening.row(v-if="this.title || this.description || this.image")
      .page-header
        h1(v-if="this.title")
          vue-markdown(:source='this.title')
        vue-markdown.desc(:source='this.description' v-if="this.description")
      div.hero(v-if="this.image")
        image-block(:payload="this.image")
    section.page-content
      component(v-if="this.page" :is="this.page")
</template>

<script>
import pageBase from '@/scenes/_pageBase.js'

// Pages
import Logo from '@/scenes/pages/logo'
import Styleguide from '@/scenes/pages/styleguide'
import Visuals from '@/scenes/pages/visuals'

export default {
  name: 'PageScene',
  mixins: [pageBase],
  components: { Logo, Styleguide, Visuals },
  data: function () {
    return {
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
  },
  computed: {
  }
}

</script>

<style lang="scss">
.article {
  img{
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/scenes/pageScene.vue